import React, { useState } from 'react';
import Layout from '../components/Layout';
import ProjectCard from '../components/ProjectCard';
import ScrollReveal from '../components/ScrollReveal';
import { projects } from '../data/mockData';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [logOpen, setLogOpen] = useState(true);

  return (
    <Layout>
      {/* Latest Log banner */}
      <div data-platform="true" className="reveal-up bg-[#1c1c1e] text-white rounded-lg p-5 mb-7">
        <button onClick={() => setLogOpen(!logOpen)} className="w-full flex items-start justify-between gap-4">
          <div className="flex items-center gap-3">
            <span className="relative inline-flex">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-400" />
              <span className="absolute inset-0 rounded-full bg-emerald-400 animate-ping opacity-60" />
            </span>
            <span className=" text-[10.5px] uppercase tracking-wider text-white/55">RhythmQ</span>
            <span className=" text-[10.5px] uppercase tracking-wider text-white/55">Mar, 2026</span>
          </div>
          <span className={`log-chevron ${logOpen ? 'is-open' : ''}`}>
            {logOpen ? <ChevronUp className="w-4 h-4 text-white/60" /> : <ChevronDown className="w-4 h-4 text-white/60" />}
          </span>
        </button>
        {logOpen && (
          <p className="mt-3 text-[13px] leading-relaxed text-white/90 expand-down">
            I’m currently building a forum and mentorship platform for nonprofit clients — designing spaces that help people connect, learn, and grow in their careers.
          </p>
        )}
      </div>

      {/* Project grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {projects.map((p, i) => (
          <ScrollReveal key={p.id} delay={i * 70}>
            <ProjectCard project={p} />
          </ScrollReveal>
        ))}
      </div>

      <div className="mt-10 pb-6 flex items-center justify-end">
        <Link to="/about" className="group btn-magnetic text-[11px] uppercase tracking-wider text-inkwell-500 hover:text-inkwell-900 flex items-center gap-2">
          About Me <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">→</span>
        </Link>
      </div>
    </Layout>
  );
}
